module.exports = __webpack_public_path__ + "img/11.e7ba12f0.svg";